module.exports = __webpack_public_path__ + "static/img/ls25.a311389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls25.png
// module id = mEsZ
// module chunks = 12